import { Boundaries } from "@planzone/core";
import { fillAccountError } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  error: fillAccountError,
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: setRequestStateToPending(),
  };
}

function handleSuccess(state: State): State {
  return {
    error: initialState.error,
    request: setRequestStateToSuccess(),
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["fillAccount"]["failure"],
): State {
  return { request: setRequestStateToFailure(), error };
}

const reduceState = createStateReducer(initialState, {
  [events.fillAccountRequested]: handleRequest,
  [events.fillAccountSucceeded]: handleSuccess,
  [events.fillAccountFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
